import { z } from "zod";

import {
  CallCompleteMessageSchema,
  CallRecapMessageSchema,
  CompleteScriptItemMessageSchema,
  InsertScriptItemMessageSchema,
  SkipToScriptItemMessageSchema,
  WarmUpNextScriptItemMessageSchema,
} from "../prompts/feedback/sdr";
import { BuyingSignalMessageSchema } from "./BuyingSignal";
import { ConversationUpdateSchema } from "./ConversationUpdate";
import { DigDeeperOpportunityMessageSchema } from "./DigDeeperOpportunity";
import { ScriptItemInsertionMessageSchema } from "./ScriptItemInsertion";

export const FeedbackMessageSchema = z.discriminatedUnion("type", [
  BuyingSignalMessageSchema,
  ConversationUpdateSchema,
  DigDeeperOpportunityMessageSchema,
  ScriptItemInsertionMessageSchema,
  InsertScriptItemMessageSchema,
  SkipToScriptItemMessageSchema,
  WarmUpNextScriptItemMessageSchema,
  CompleteScriptItemMessageSchema,
  CallRecapMessageSchema,
  CallCompleteMessageSchema,
]);

export type FeedbackMessage = z.infer<typeof FeedbackMessageSchema>;
